import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { TestResultTileComponent } from './test-result-tile/test-result-tile.component';
import { LevelTestResultsCarouselComponent } from './level-test-results-carousel/level-test-results-carousel.component';
import { LevelTestResultsSectionComponent } from './level-test-results-section/level-test-results-section.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    TestResultTileComponent,
    LevelTestResultsCarouselComponent,
    LevelTestResultsSectionComponent
  ],
  exports: [LevelTestResultsSectionComponent],
})
export class TestResultsModule {}


// WEBPACK FOOTER //
// ./ts/app/test-results/test-results.module.ts